import { useErrorHandlers } from "@/errors/components/error-handling-context";
import {
  notLoggedInError,
  projectPermissionError,
} from "@/errors/unrecoverable-error";
import {
  AuthenticationError,
  AuthorizationError,
} from "@faro-lotv/service-wires";
import { useCallback } from "react";

type HandleTokenAuthErrorFunction = (
  error: AuthenticationError | AuthorizationError,
) => void;

/**
 *  @returns a function that handles authentication and authorization errors of the token request.
 */
export function useHandleTokenAuthError(): HandleTokenAuthErrorFunction {
  const { handleErrorWithPage } = useErrorHandlers();

  return useCallback(
    (error: AuthenticationError | AuthorizationError): void => {
      if (error instanceof AuthenticationError) {
        handleErrorWithPage(notLoggedInError(error));
      } else {
        handleErrorWithPage(projectPermissionError(error));
      }
    },
    [handleErrorWithPage],
  );
}
